module.exports = __webpack_public_path__ + "static/media/futura-bold-bt.7509ab66.ttf";